import { Box } from '@mui/material';
import React from 'react';

import { spaces } from '../../../../../assets/styles/themes/tokens';

const MuiCardBaseLongTextsWrapper: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => (
	<Box sx={{ display: 'flex', flexFlow: 'column', gap: spaces.xs }}>{children}</Box>
);

export default MuiCardBaseLongTextsWrapper;
